export default {"src":"/_next/static/media/builts.b25d528e.svg","height":160,"width":160};